module.exports = __webpack_public_path__ + "static/img/TAF_Shulin.00970b96.jpg";